import { __ } from '@wordpress/i18n';
import './SelectScopeValuesMessage.css';

export const SELECT_SCOPE_VALUES_MSG = __(
	'Select a value for each scope to view available inventory.',
	'gp-inventory'
);

export function SelectScopeValuesMessage() {
	return (
		<span className="select-scope-value-message">
			{SELECT_SCOPE_VALUES_MSG}
		</span>
	);
}
